import { createNamespacedHelpers } from 'vuex'

const app = createNamespacedHelpers('app')

export default {
  data() {
    return {
      messageLevel: {
        success: 'success',
        warning: 'warning',
        info: 'info',
        error: 'error',
      },
      messageList: [],
      snackbar: {
        //determine snackbar show or not
        isSnackbarShow: false,
        snackbarMessage: '',
        snackbarColor: '',
      },
    }
  },
  methods: {
    ...app.mapActions(['addMessage']),
    setMessage(level, title, content, nextStep = '') {
      var options = {
        level: level,
        title: title,
        content: content,
        nextStep: nextStep,
      }
      this.appendMessage(options)
      this.addMessage(options)
    },
    appendMessage(options) {
      this.messageList.push(options)
    },
    showSnackbar(message = '', color = '', timeout = 2000) {
      this.snackbar.isSnackbarShow = true
      this.snackbar.snackbarColor = color
      this.snackbar.snackbarMessage = message
      this.snackbar.timeout = timeout
    },
    outputMessageList(includeLevel = [this.messageLevel.error]) {
      let match = this.messageList.filter(x => includeLevel.includes(x.level))
      if (match.length == 0) {
        return
      }
      this.snackbar.isSnackbarShow = true
      this.snackbar.snackbarColor = this.messageTopLevel(match)
      this.snackbar.snackbarMessage = match.map(x => x.content).join('<br/>')
    },
    hideSnackbar() {
      this.snackbar.isSnackbarShow = false
    },
    messageTopLevel(data) {
      let levelSet = [...new Set(data.map(x => x.level))]
      if (levelSet.includes('error')) {
        return 'error'
      } else if (levelSet.includes('warning')) {
        return 'warning'
      } else if (levelSet.includes('success')) {
        return 'success'
      } else if (levelSet.includes('info')) {
        return 'info'
      } else {
        return null
      }
    },
  },
  computed: {
    hasMessage() {
      return (this.messageList.length > 0)
    },
  },
}